import React from 'react';
import classNames from 'classnames';

import styles from './UserStatus.module.scss';

interface UserStatusProps {
  allowed: boolean;
}

export function UserStatus(props: UserStatusProps) {
  const { allowed } = props;

  return (
    <div className={classNames(styles.container, { [styles.allowed]: allowed })}>
      {allowed ? 'Allowed user' : 'Blocked user'}
    </div>
  );
}
